import { render, staticRenderFns } from "./DeleteResourceConfirm.vue?vue&type=template&id=015982ba&"
import script from "./DeleteResourceConfirm.vue?vue&type=script&lang=ts&"
export * from "./DeleteResourceConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports